import { useQuery } from '@tanstack/react-query';
import { fetchTweetData } from '@/lib/twitter';

/** Fetches tweet data (including video URLs) for a given Twitter/X URL */
export function useTweetVideo(tweetUrl: string | null) {
  return useQuery({
    queryKey: ['tweet-video', tweetUrl],
    queryFn: async ({ signal }) => {
      if (!tweetUrl) throw new Error('No URL provided');
      return fetchTweetData(tweetUrl, signal);
    },
    enabled: !!tweetUrl,
    retry: false,
    staleTime: Infinity,
  });
}
